var $d5f46c2b8dfe6400$exports = {};
function $d5f46c2b8dfe6400$var$debounce(func, delay) {
    let timeoutId;
    return function(...args) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(()=>{
            func.apply(this, args);
        }, delay);
    };
}
function $d5f46c2b8dfe6400$var$resizeCanvas(riveInstance) {
    if (riveInstance && riveInstance._canvas) {
        const canvas = riveInstance._canvas;
        canvas.width = canvas.clientWidth;
        canvas.height = canvas.clientHeight;
        riveInstance?.resizeDrawingSurfaceToCanvas();
    }
}
const $d5f46c2b8dfe6400$var$celebrate_anim = new rive.Rive({
    src: "/public/character_animations.riv",
    canvas: document.getElementById("celebrate-canvas"),
    autoplay: true,
    stateMachines: "Celebrate-State-Machine",
    onLoad: ()=>{
        $d5f46c2b8dfe6400$var$resizeCanvas($d5f46c2b8dfe6400$var$celebrate_anim);
    }
});
const $d5f46c2b8dfe6400$var$celebrate_anim2 = new rive.Rive({
    src: "/public/character_animations.riv",
    canvas: document.getElementById("celebrate-canvas2"),
    autoplay: true,
    artboard: "Square-Phone",
    stateMachines: "Square-Phone-State-Machine",
    onLoad: ()=>{
        $d5f46c2b8dfe6400$var$resizeCanvas($d5f46c2b8dfe6400$var$celebrate_anim2);
    }
});
window.addEventListener("resize", $d5f46c2b8dfe6400$var$debounce(()=>{
    $d5f46c2b8dfe6400$var$resizeCanvas($d5f46c2b8dfe6400$var$celebrate_anim);
    $d5f46c2b8dfe6400$var$resizeCanvas($d5f46c2b8dfe6400$var$celebrate_anim2);
}, 250));


//# sourceMappingURL=video-production.a1b06b3f.js.map
